export const LOW_BUDGET_THRESHOLD = 350
export const VIDEOS_BASED_SLIDER_STEP = 10

export const getParsedBudgetValue = (
  value: string,
  currencySymbol?: string,
): number | null => {
  const symbol = currencySymbol || ''
  const raw = value.slice(symbol.length).replace(/[,\s]/g, '')

  if (raw === '') {
    return 0
  }

  const numberValue = Number(raw)

  return Number.isNaN(numberValue) ? null : numberValue
}

export const getBaseBudgetValue = (
  value: number,
  rate?: number,
): number | null => {
  if (typeof rate !== 'number' || rate <= 0) {
    return null
  }

  return Math.round(value / rate)
}

export const canSaveBudget = (value: number, min: number): boolean =>
  Number.isFinite(value) && value >= min
